/**
 * 위반 식별 합성키 (DL id + cell id).
 *
 * 백엔드 `app/guideline/domain/vo/dl_cell_key.py`와 동일 규약.
 * cell id는 `:`(세그먼트 구분)와 빈 세그먼트로 인한 `::`를 포함할 수 있지만,
 * DL id는 영숫자 role id라 `::`를 포함하지 않는다. 따라서 `{dlId}::{cellId}`로
 * 조립하고 **첫 `::`에서만** 분리한다.
 */

export const DL_CELL_KEY_SEPARATOR = "::";

export function buildDlCellKey(dlId: string, cellId: string): string {
  return `${dlId}${DL_CELL_KEY_SEPARATOR}${cellId}`;
}

export function parseDlCellKey(key: string): { dlId: string; cellId: string } {
  const idx = key.indexOf(DL_CELL_KEY_SEPARATOR);
  if (idx < 0) return { dlId: key, cellId: "" };
  return {
    dlId: key.slice(0, idx),
    cellId: key.slice(idx + DL_CELL_KEY_SEPARATOR.length),
  };
}
